import { useAppSelector } from "../../../hooks";
import type { OnboardingRole } from "../../../slices/onboardingSlice";

export function useOnboardingRole(): OnboardingRole {
  const activeRole = useAppSelector((state) => state.auth.activeRole);
  const valid: OnboardingRole[] = ["Admin", "Manager", "Cashier"];

  if (activeRole && valid.includes(activeRole as OnboardingRole)) {
    return activeRole as OnboardingRole;
  }

  return "Admin";
}
